// extracted by mini-css-extract-plugin
var _1 = "BirdviewAgingChart-moduleaging__FRo3c";
var _2 = "BirdviewAgingChart-modulecaption__PEs_D";
var _3 = "BirdviewAgingChart-modulecaptionText__hdv5N Text-moduletext__Z2j5F";
var _4 = "BirdviewAgingChart-modulechart__O2apY";
var _5 = "BirdviewAgingChart-modulecolumns__ruUPx";
var _6 = "BirdviewAgingChart-modulecount__J7IYl BirdviewAgingChart-modulecaptionText__hdv5N Text-moduletext__Z2j5F";
var _7 = "BirdviewAgingChart-modulecovered__Nq_gi BirdviewAgingChart-modulecaptionText__hdv5N Text-moduletext__Z2j5F";
var _8 = "BirdviewAgingChart-modulewrap__KQ2Bv";
export { _1 as "aging", _2 as "caption", _3 as "captionText", _4 as "chart", _5 as "columns", _6 as "count", _7 as "covered", _8 as "wrap" }
